import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { environment } from '../../../../../../environments/environment';
import * as properties from '../../../../../../properties.json';

@Injectable()
export class MapUtil {
  constructor(private http: HttpClient) { }

  public getLatLng(address: string, city: string, state: string): any {
    let addressString: string = address && encodeURIComponent(address);
    addressString += city && ',' + encodeURIComponent(city);
    addressString += state && ',' + encodeURIComponent(state);
    if (!addressString) {
      return null;
    }
    if (properties.enableLoadTest != 'true') {
      return this.http.get(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${addressString}&key=${environment.googleApiKey
        }`
      );
    }
    return this.http.get('assets/test-data/lat-long-mock-data.json');
  }

  public getLatLngAddressOnly(address: string): any {
    const addressString: string = address && encodeURIComponent(address);
    if (!addressString) {
      return of(null);
    }
    if (properties.enableLoadTest != 'true') {
      return this.http.get(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${addressString}&key=${environment.googleApiKey
        }`
      );
    }
    return this.http.get('assets/test-data/lat-long-mock-data.json');
  }

  public getTimeZoneByLocation(latitude: string, longitude: string): any {
    let timestamp = Math.floor((new Date).getTime() / 1000);
    if (properties.enableLoadTest != 'true') {
      return this.http.get(
        `https://maps.googleapis.com/maps/api/timezone/json?location=${latitude},${longitude}&timestamp=${timestamp}&key=${environment.googleApiKey}`
      );
    }
    return this.http.get('assets/test-data/time-zones-mock-data.json');
  }
}
